import { useState } from "react";
import { IntlPhoneFieldProps } from "./interface";
import "./intlPhoneField.scss";
import constant from "../../../constants/constant";

const IntlPhoneField: React.FC<IntlPhoneFieldProps> = ({
    label,
    htmlFor,
    placeholder,
    id,
    disabled = false,
    value,
    onChange,
    errors,
    className
}): JSX.Element => {
    // Retrieve region code from localStorage and convert it to a number
    const regionCode: boolean = Number(localStorage.getItem("store_region")) === constant.STORE_REGION.KUWAIT;
    // end

    // Country code drop down
    const CountryDropDown = (): JSX.Element => {
        const selectedCountry = regionCode
            ? constant?.COUNTRY_CODES[1]
            : constant?.COUNTRY_CODES[0];

        return (
            <span className="d-none d-md-flex input-group-text align-items-center gap-2" id="addon-wrapping">
                <span>{selectedCountry?.flag}</span>
                <span>{selectedCountry?.code}</span>
            </span>
        );
    };

    // end

    // to handle the onchange function
    const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value as string;
        const maxLength = regionCode ? constant.KUWAIT_NUMBER_LENGTH : constant.INDIA_NUMBER_LENGTH;
        const isValidNumber = /^\d+$/.test(inputValue);

        if (inputValue.length <= maxLength) {
            onChange(inputValue && isValidNumber ? Number(inputValue) : '');
        }
    };
    // end

    return (
        <div className="form-group">
            {label && (
                <label
                    className="inputs-label mb-2 fs-16 fw-600 secondary-color"
                    htmlFor={htmlFor}
                >
                    {label}
                </label>
            )}
            <div className="input-group ps-1 ps-md-0">
                {<CountryDropDown />}
                <input
                    type="text"
                    className={ "intl-phone-inputs form-control"}
                    aria-label="Phone number input with country code dropdown"
                    placeholder={placeholder}
                    id={id}
                    disabled={disabled}
                    value={value}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnchange(e)}
                />
            </div>
            {errors && <span className="error-text">{errors}</span>}
        </div>
    );
};

export default IntlPhoneField;
